import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./HowToGetPrepared.module.scss";

interface IHowToGetPrepared {
  title: string;
  description: string;
  subtitle?: string;
  isLoading: boolean;
}

const HowToGetPrepared: FC<IHowToGetPrepared> = ({
  title,
  description,
  subtitle,
}) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.infoSection} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h3
        className={`${styles.title} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        {title}
      </h3>
      {subtitle && (
        <h4
          className={styles.subtitle}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
      <p
        className={`${styles.description} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

export default HowToGetPrepared;
